import React from "react";
import styled from "styled-components";
import Overlay from "../components/Overlay";

const Card = () => {
  return (
    <CardSection>
      <CardSubHeading>Our Services</CardSubHeading>
      <Overlay />
    </CardSection>
  );
};

export default Card;

const CardSection = styled.div`
  max-width: 1200px;
  margin: auto;
  margin-top: 10rem;
`;

const CardSubHeading = styled.h1`
  color: var(--color-blue);
  font-weight: bolder;
  letter-spacing: 2px;
  font-size: 2.5rem;
  margin-bottom: 2rem;
`;
